import * as jwtDecode from 'jwt-decode'
import constants from '../config/constants'

const tokenIsValid = token => {
  try {
    const decodedJwt = jwtDecode(token)
    return decodedJwt.exp >= Date.now() / 1000 + constants.JWT_REFRESH_THRESHOLD
  } catch (e) {
    return false
  }
}

const isLoggedIn = () => {
  const commandeerToken = window.localStorage.getItem('commandeer_token')
  if (commandeerToken && !tokenIsValid(commandeerToken)) return false
  if (commandeerToken) return true

  const token = window.localStorage.getItem('bearer_token')
  if (!token) return false
  if (!tokenIsValid(token)) return false

  return true
}

export default isLoggedIn
